//todo: heads are remaining
import CorporateResourceHeadLayout from "./CorporateResource/CorporateResourceHeadLayout";
import FinanceLayout from "./CorporateResource/FinanceLayout";
import CorporateResourceMangDevLayout from "./CorporateResource/CorporateResourceMangDevLayout";
import EICLayout from "./EIC/EICLayout";
import EICHeadLayout from "./EIC/EICHeadLayout";
import ExecutiveLayout from "./Executives/ExecutiveLayout";
import LandAndInfraDevelopmentHeadLayout from "./LandAndInfrastructure/LandAndInfraDevelopmentHeadLayout";
import DesignAndConstructionLayout from "./LandAndInfrastructure/DesignAndConstructionLayout";
import DesignAndConstructionHeadLayout from "./LandAndInfrastructure/DesignAndConstructionHeadLayout";
import MPandLBHeadLayout from "./LandAndInfrastructure/MPandLBHeadLayout";
import GISLayout from "./LandAndInfrastructure/GISLayout";
import OperationAndManagementHeadLayout from "./OperationAndManagement/OperationAndManagementHeadLayout";
import InvestorAftercareLayout from "./OperationAndManagement/InvestorAftercareLayout";
import InvestorAftercareHeadLayout from "./OperationAndManagement/InvestorAftercareHeadLayout";
import ParkAdminLayout from "./Park/ParkAdminLayout";
import ParkStaffLayout from "./Park/ParkStaffLayout";
import PromotionAndMarketingLayout from "./PromotionAndMarketing/PromotionAndMarketingLayout";
import InvestmentPromoAndMarkDevLayout from "./PromotionAndMarketing/InvestmentPromoAndMarkDevLayout";

import SystemAdminLayout from "./SystemAdmin/SystemAdminLayout";
import SystemAdminHeadLayout from "./SystemAdmin/SystemAdminHeadLayout";

export {
  CorporateResourceHeadLayout,
  FinanceLayout,
  EICHeadLayout,
  EICLayout,
  ExecutiveLayout,
  LandAndInfraDevelopmentHeadLayout,
  DesignAndConstructionLayout,
  DesignAndConstructionHeadLayout,
  MPandLBHeadLayout,
  GISLayout,
  OperationAndManagementHeadLayout,
  InvestorAftercareLayout,
  ParkAdminLayout,
  ParkStaffLayout,
  PromotionAndMarketingLayout,
  SystemAdminHeadLayout,
  SystemAdminLayout,
  InvestorAftercareHeadLayout,
  CorporateResourceMangDevLayout,
  InvestmentPromoAndMarkDevLayout,
};
